import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base = "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors";

export const BtnPrimary = ({ to, children, testid, className = "" }) => (
  <Link to={to} data-testid={testid}
    className={`${base} bg-brand text-white px-8 py-4 hover:bg-navy shadow-lg shadow-brand/20 ${className}`}>
    {children} <ArrowRight size={18} />
  </Link>
);

export const BtnSecondary = ({ to, children, testid, className = "" }) => (
  <Link to={to} data-testid={testid}
    className={`${base} bg-white text-navy border border-navy/10 px-8 py-4 hover:bg-aqua ${className}`}>
    {children}
  </Link>
);

export const BtnAccent = ({ to, children, testid, className = "" }) => (
  <Link to={to} data-testid={testid}
    className={`${base} bg-gold text-navy px-8 py-4 font-bold hover:brightness-105 ${className}`}>
    {children} <ArrowRight size={18} />
  </Link>
);
